import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { sentry } from 'sentry';
import { MfaService } from '../../../services/mfa.service';

@Component({
  selector: 'insert-password',
  templateUrl: './insert-password.component.html',
  styleUrls: ['./insert-password.component.scss']
})
export class InsertPasswordComponent {
  @Input()
  public isLoading: boolean;

  @Input()
  public isClose: boolean;

  @Output()
  public back: EventEmitter<void>;

  @Output()
  public next: EventEmitter<string>;

  public passwordControl: FormControl;
  public showPassword: boolean;

  constructor(
    private readonly mfaService: MfaService,
    private readonly fuseProgressBarService: FuseProgressBarService
  ) {
    this.showPassword = false;
    this.back = new EventEmitter<void>();
    this.next = new EventEmitter<string>();
    this.passwordControl = new FormControl(null, [Validators.required]);
  }

  public async generateTemporaryToken(): Promise<void> {
    try {
      this.isLoading = true;
      this.fuseProgressBarService.show();

      const input = { password: this.passwordControl.value };
      const temporaryToken = await this.mfaService.regenerateToken(input);

      this.isLoading = false;
      this.fuseProgressBarService.hide();

      this.next.emit(temporaryToken);
    } catch (err) {
      this.isLoading = false;
      this.fuseProgressBarService.hide();
      const code = getErrorCode(err);
      if (code === 'NotAuthorizedException') {
        this.passwordControl.setErrors({ incorrect: true });
        return;
      }

      sentry.captureException(err, {
        extra: {
          message: 'Error on insert password to generate temporary token',
          err: JSON.stringify(err)
        }
      });
    }
  }
}
